import { collection, doc, getDocs, Timestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../config';
import { masterStatus } from '../../../../constants/enum';

/**
 * マスタを論理削除する（#2896）。
 * 物理削除はせず、master ドキュメントと配下の master_mappings を status=99 にする。
 * 運営が後からマスタ・マッピングの使われ方を確認できるよう、データは残す。
 * Cloud SQL の master_records / master_field_mappings は残す（照合側は status で除外）。
 */
export const deleteMaster = async (masterId: string): Promise<void> => {
  const now = Timestamp.now();

  // 配下サブコレクション master_mappings を論理削除
  const mappingsRef = collection(db, 'masters', masterId, 'master_mappings');
  const snapshot = await getDocs(mappingsRef);
  await Promise.all(
    snapshot.docs.map(d => updateDoc(d.ref, { status: masterStatus.deleted, updated_at: now })),
  );

  // 親 master を論理削除
  await updateDoc(doc(db, 'masters', masterId), {
    status: masterStatus.deleted,
    updated_at: now,
  });
};
